module.exports = __webpack_public_path__ + "img/step06_a_stand_basic_left_bottom_cross.16a0c64a.png";